var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGifts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24.855 6.383H13.79l3.585-5.118c.119-.16.119-.439-.079-.558-.158-.12-.435-.12-.553.08L13 6.142 9.5 1.265c-.119-.16-.395-.2-.553-.08s-.198.4-.08.56l3.343 4.638H1.145c-.237 0-.395.16-.395.399v3.99c0 .239.158.399.395.399h1.58v11.57c0 .24.159.4.396.4h19.758c.237 0 .395-.16.395-.4v-11.57h1.58c.238 0 .396-.16.396-.4v-3.99c0-.239-.158-.398-.395-.398zM1.54 7.18h11.065v3.192H1.54zm1.976 3.99h9.089v11.171H3.516v-11.17zm18.968 11.171h-9.089v-11.17h9.089v11.171zm1.976-11.97H13.395V7.182H24.46v3.192z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifts);
export default __webpack_public_path__ + "static/media/gifts.93bdadc2.svg";
export { ForwardRef as ReactComponent };